import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useOnlineRoom } from '../../hooks/useOnlineRoom';
import LobbyScreen from './components/LobbyScreen';
import WaitingScreen from './components/WaitingScreen';
import OnlineGameBoard from './components/OnlineGameBoard';

export default function OnlineGamePage() {
  const {
    status,
    room,
    isHost,
    playerId,
    error,
    createRoom,
    joinRoom,
    leaveRoom,
    send,
    onEvent,
    finishGame,
  } = useOnlineRoom();

  // Scroll to top on mount
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-50 to-white pt-20 pb-12">
      {/* Page Header */}
      <div className="max-w-5xl mx-auto px-6">
        <nav className="flex items-center gap-2 text-xs text-gray-400 mb-6">
          <Link to="/" className="hover:text-sky-600 cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-sky-600 font-medium">Online Match</span>
        </nav>

        {status === 'idle' || status === 'creating' || status === 'joining' || status === 'error' ? (
          <LobbyScreen
            onCreateRoom={createRoom}
            onJoinRoom={joinRoom}
            isLoading={status === 'creating' || status === 'joining'}
            error={error}
          />
        ) : status === 'waiting' && room ? (
          <WaitingScreen room={room} onCancel={leaveRoom} />
        ) : status === 'playing' && room ? (
          <>
            {/* Match info bar */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-sky-100 rounded-full">
                  <i className="ri-global-line text-sky-600" />
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-800">
                    {room.host_name} <span className="text-gray-400 font-normal">vs</span> {room.guest_name ?? '…'}
                  </p>
                  <p className="text-xs text-gray-400 capitalize">{room.game_type} · {room.difficulty} · Room {room.room_code}</p>
                </div>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" />
                </span>
                <span className="text-xs text-green-600 font-medium">Live</span>
              </div>
            </div>

            <OnlineGameBoard
              room={room}
              isHost={isHost}
              playerId={playerId}
              send={send}
              onEvent={onEvent}
              onLeave={leaveRoom}
              finishGame={finishGame}
            />
          </>
        ) : (
          <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4">
            <span className="text-gray-400 text-sm">Connecting…</span>
          </div>
        )}
      </div>
    </div>
  );
}
